import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import "../vendor.css";

const bottomNav = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
  },
  {
    to: "/products",
    label: "Products",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 01-8 0"/>
      </svg>
    ),
  },
  {
    to: "/orders",
    label: "Orders",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
        <rect x="9" y="3" width="6" height="4" rx="1"/>
        <line x1="9" y1="12" x2="15" y2="12"/>
        <line x1="9" y1="16" x2="13" y2="16"/>
      </svg>
    ),
  },
  {
    to: "/payouts",
    label: "Payouts",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2"/>
        <line x1="2" y1="10" x2="22" y2="10"/>
      </svg>
    ),
  },
  {
    to: "/reviews",
    label: "Reviews",
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ),
  },
];

export default function VendorLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const title = getTitle(location.pathname);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <div style={{
      display: "flex", flexDirection: "row",
      minHeight: "100vh", width: "100%",
      background: "#f6f7fb", overflowX: "hidden", boxSizing: "border-box",
    }}>
      {!isMobile && <Sidebar />}
      <div style={{
        flex: 1, minWidth: 0, display: "flex", flexDirection: "column",
        background: "#f6f7fb",
        paddingTop: isMobile ? "56px" : "0",
        paddingBottom: isMobile ? "64px" : "0",
      }}>
        <Topbar title={title} />
        {isMobile && <Sidebar />}
        <div style={{ padding: "20px", minWidth: 0 }}>
          <Outlet />
        </div>
      </div>

      {isMobile && (
        <div style={{
          position: "fixed", bottom: 0, left: 0, right: 0, height: 64,
          background: "#fff", borderTop: "1px solid #eee",
          display: "flex", alignItems: "center", justifyContent: "space-around",
          zIndex: 500, boxShadow: "0 -2px 12px rgba(0,0,0,0.08)",
        }}>
          <style>{`.v-bnav-btn { background: #ffffff !important; border: none !important; cursor: pointer; display: flex; flex-direction: column; align-items: center; gap: 3px; padding: 6px 10px; flex: 1; }`}</style>
          {bottomNav.map((item) => {
            const active = location.pathname.startsWith(item.to);
            return (
              <button
                key={item.to}
                onClick={() => navigate(item.to)}
                className="v-bnav-btn"
                style={{ borderTop: active ? "2px solid #ff6a00" : "2px solid transparent" }}
              >
                {item.icon(active)}
                <span style={{ fontSize: 10, fontWeight: 700, color: active ? "#ff6a00" : "#111" }}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

function getTitle(pathname = "") {
  const p = pathname.toLowerCase();
  if (p.startsWith("/main-categories")) return "Main Categories"; // ✅ Fixed
  if (p.startsWith("/sub-categories"))  return "Sub Categories";
  if (p.startsWith("/products"))        return "Products";
  if (p.startsWith("/orders"))          return "Orders";
  if (p.startsWith("/payouts"))         return "Payouts";
  if (p.startsWith("/profile"))         return "Profile";
  if (p.startsWith("/dashboard"))       return "Dashboard";
  return "Vendor Panel";
}

//new

// import React, { useState, useEffect } from "react";
// import { Outlet, useLocation, useNavigate } from "react-router-dom";
// import Sidebar from "./components/Sidebar";
// import Topbar from "./components/Topbar";
// import "../vendor.css";

// const bottomNav = [
//   {
//     to: "/dashboard",
//     label: "Dashboard",
//     icon: (active) => (
//       <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
//         stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <rect x="3" y="3" width="7" height="7" rx="1"/>
//         <rect x="14" y="3" width="7" height="7" rx="1"/>
//         <rect x="3" y="14" width="7" height="7" rx="1"/>
//         <rect x="14" y="14" width="7" height="7" rx="1"/>
//       </svg>
//     ),
//   },
//   {
//     to: "/products",
//     label: "Products",
//     icon: (active) => (
//       <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
//         stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
//         <line x1="3" y1="6" x2="21" y2="6"/>
//         <path d="M16 10a4 4 0 01-8 0"/>
//       </svg>
//     ),
//   },
//   {
//     to: "/orders",
//     label: "Orders",
//     icon: (active) => (
//       <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
//         stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
//         <rect x="9" y="3" width="6" height="4" rx="1"/>
//         <line x1="9" y1="12" x2="15" y2="12"/>
//         <line x1="9" y1="16" x2="13" y2="16"/>
//       </svg>
//     ),
//   },
//   {
//     to: "/payouts",
//     label: "Payouts",
//     icon: (active) => (
//       <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
//         stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <rect x="2" y="5" width="20" height="14" rx="2"/>
//         <line x1="2" y1="10" x2="22" y2="10"/>
//       </svg>
//     ),
//   },
//   {
//     to: "/reviews",
//     label: "Reviews",
//     icon: (active) => (
//       <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
//         stroke={active ? "#ff6a00" : "#111"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//       </svg>
//     ),
//   },
// ];

// export default function VendorLayout() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const title = getTitle(location.pathname);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const handler = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, []);

//   return (
//     <div className="v-layout-root">

//       {/* ── Sidebar — desktop only ── */}
//       {!isMobile && <Sidebar />}

//       {/* ── Main column ── */}
//       <div className="v-layout-main">

//         {/* Topbar */}
//         <Topbar title={title} />

//         {/* Mobile sidebar (hidden on desktop) */}
//         {isMobile && <Sidebar />}

//         {/* Page content */}
//         <div className="v-layout-content">
//           <Outlet />
//         </div>
//       </div>

//       {/* ── Mobile bottom nav ── */}
//       {isMobile && (
//         <div className="v-bottom-nav">
//           <style>{`.v-bnav-btn { background: #ffffff !important; border: none !important; cursor: pointer; display: flex; flex-direction: column; align-items: center; gap: 3px; padding: 6px 10px; flex: 1; }`}</style>
//           {bottomNav.map((item) => {
//             const active = location.pathname.startsWith(item.to);
//             return (
//               <button
//                 key={item.to}
//                 onClick={() => navigate(item.to)}
//                 className="v-bnav-btn"
//                 style={{ borderTop: active ? "2px solid #ff6a00" : "2px solid transparent" }}
//               >
//                 {item.icon(active)}
//                 <span style={{ fontSize: 10, fontWeight: 700, color: active ? "#ff6a00" : "#111" }}>
//                   {item.label}
//                 </span>
//               </button>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }

// function getTitle(pathname = "") {
//   const p = pathname.toLowerCase();
//   if (p.startsWith("/main-categories")) return "Main Categories";
//   if (p.startsWith("/sub-categories"))  return "Sub Categories";
//   if (p.startsWith("/products"))        return "Products";
//   if (p.startsWith("/orders"))          return "Orders";
//   if (p.startsWith("/payouts"))         return "Payouts";
//   if (p.startsWith("/profile"))         return "Profile";
//   if (p.startsWith("/dashboard"))       return "Dashboard";
//   if (p.startsWith("/reviews"))         return "Reviews";
//   return "Vendor Panel";
// }